import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { ClientEntity } from "../types/ClientEntity";
import { ClientEntityFormInput } from "../components/CreateClientEntityModal";
import { GET_CLIENT_ENTITIES_FETCH_KEY } from "./useGetClientEntities";

export const createClientEntity = async (
  newClientEntity: Partial<ClientEntityFormInput>,
): Promise<ClientEntity> => {
  const response = await fetcher.post(
    `${API.GESLUB}/client-entities`,
    newClientEntity,
  );
  return response.data;
};

export const useCreateClientEntity = () => {
  const queryClient = useQueryClient();

  return useMutation<ClientEntity, Error, Partial<ClientEntityFormInput>>({
    mutationFn: createClientEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_CLIENT_ENTITIES_FETCH_KEY],
      });
    },
    onError: (error) => {
      console.error("Error creating work order:", error);
    },
  });
};
